import React, { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import colors from '../../theme/colors';

// cells: { cell_1: 3.312, cell_2: 3.315, ... cell_96: 3.310 }
export default function CellHeatmap({ cells, title, rows = 6, cols = 16 }) {
  const options = useMemo(() => {
    if (!cells) return null;

    const data = [];
    let min = Infinity, max = -Infinity;
    for (let i = 0; i < rows * cols; i++) {
      const key = `cell_${i + 1}`;
      const val = cells[key];
      if (val != null && val > 0) {
        const row = Math.floor(i / cols);
        const col = i % cols;
        data.push([col, row, Math.round(val * 1000) / 1000]);
        if (val < min) min = val;
        if (val > max) max = val;
      }
    }

    if (data.length === 0) return null;

    const xCats = Array.from({ length: cols }, (_, i) => String(i + 1));
    const yCats = Array.from({ length: rows }, (_, i) => `Row ${i + 1}`);

    return {
      chart: {
        type: 'heatmap',
        height: rows * 40 + 80,
      },
      title: { text: title || 'Cell Voltages' },
      xAxis: {
        categories: xCats,
        title: { text: 'Cell' },
        labels: { style: { fontSize: '10px' } },
      },
      yAxis: {
        categories: yCats,
        title: null,
        reversed: true,
        labels: { style: { fontSize: '10px' } },
      },
      colorAxis: {
        min: min - 0.01,
        max: max + 0.01,
        stops: [
          [0, colors.danger],
          [0.5, colors.warning],
          [1, colors.success],
        ],
        labels: { style: { color: colors.textMuted } },
      },
      series: [{
        name: 'Voltage',
        data,
        borderWidth: 1,
        borderColor: colors.card,
        dataLabels: {
          enabled: true,
          format: '{point.value:.3f}',
          style: { fontSize: '9px', fontWeight: 'normal', color: '#fff', textOutline: 'none' },
        },
        tooltip: {
          pointFormat: 'Cell {point.x1}: <b>{point.value:.3f}V</b>',
        },
      }],
      legend: {
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'middle',
      },
    };
  }, [cells, title, rows, cols]);

  if (!options) {
    return <div style={{ padding: 20, color: colors.textMuted, fontSize: 13 }}>No cell data</div>;
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
